import { render } from "./ListTransition.vue?vue&type=template&id=2d8c49aa&scoped=true"
import script from "./ListTransition.vue?vue&type=script&lang=js"
export * from "./ListTransition.vue?vue&type=script&lang=js"

import "./ListTransition.vue?vue&type=style&index=0&id=2d8c49aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8c49aa"]])

export default __exports__